module.exports = __webpack_public_path__ + "static/media/Jude Monye.21b5c83f.jpg";